<template>
    <div class="client-container">
        <headline :params="headLines" />
        <div class="client-content">
            <div class="left-container">
                <div class="title"><p>客户端订阅</p></div>
                <div class="content">
                    <ul>
                        <li @click="client_id = '';clientIndex = 9999;getClientNews('')"  :class="{on: clientIndex-0 === 9999}">全部（{{clients.length}}/{{total}}）</li>
                        <li @click="client_id = item.client_id;page.pageIndex = 1;clientIndex = index;getClientNews(item.client_id)" :class="{on: clientIndex-0 === index}" v-for="(item, index) in clients" :key="item.client_id">{{item.client_name}}</li>
                    </ul>
                </div>
                <div class="footer">
                    <div>
                        <p @click="showCheckList = true">
                            <i></i>
                            <span>订阅来源</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="right-container">
                <div class="list">
                    <div @click="reload" v-if="showNews" class="hasNew">
                        <i></i>
                        有新动态，点击刷新
                    </div>
                    <empty style="min-height: 100%" v-if="list.length == 0" :msg="'暂无客户端动态'"></empty>
                    <div v-if="list.length > 0" :style="'height:'+ height +'px'" class="progress"></div>
                    <ul v-if="list.length > 0" ref="list">
                        <li @click="toDetail(item.id)" v-for="item in list" :key="item.id">
                            <div class="left">
                                <!-- <img :src="item.icon" alt=""> -->
                                <div class="content">
                                    <div class="title">
                                        <p>{{item.client_name}}</p>
                                        <i :class="{on: item.hbUrlTime === '刚刚'}">{{item.hbUrlTime}}</i>
                                    </div>
                                    <div class="content">{{item.hbUrlTitle}}</div>
                                </div>
                            </div>
                            <div @click.stop="copy(item.hbUrlTitle)" class="right">复制</div>
                            <div class="time">
                                <p>{{item.date}}</p>
                                <p>{{item.time}}</p>
                            </div>
                        </li>
                    </ul>
                    <div v-if="!canLoad" class="empty1">
                        <i></i>
                        <span>没有更多啦</span>
                    </div>
                </div>
            </div>
        </div>
        <browser v-if="showBrowser" @close="showBrowser = false" :url="detail"></browser>
        <checkList @submit="submit" @search="search" :need_push="need_push" :list="clientsList" v-if="showCheckList"></checkList>
        <input type="text" style="position: absolute;top: -100000px;" id="copyInput">
   </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import checkList from "@components/checkList";
import browser from "@components/browser";
import empty from "@components/empty";

export default {
    components: {
        headline,
        checkList,
        browser,
        empty
    },
    data() {
        return {
            need_push: 1,
            showNews: false,
            showBrowser: false,
            canLoad: true,
            client_id: "",
            showCheckList: false,
            height: 0,
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            page: {
                page_count: 0,
                pageIndex: 1,
                pageSize: 20,
                total: 0
            },
            clientsList: [],
            clients: [],
            clientIndex: 9999,
            list: [],
            total: 0,
            userNum: 0,
            detail: {

            }
        }
    },
    methods: {
        reload() {
            this.page.pageIndex = 1;
            this.getClientNews(this.client_id)
            this.showNews = false;
        },
        toDetail(id) {
            let info = {
                id: id || ''
            }
            common.myFetch(apis.newsdetail, info).then(res => {
                if(res){
                    let hbUrlName = res.detail.hbUrlName
                    hbUrlName = hbUrlName.replace('http://', 'https://')
                    res.detail.hbUrlNameHttps = hbUrlName
                    this.detail = res.detail
                    this.showBrowser = true
                    console.log(res)
                }
            })
        },
        copy(content) {
            let dom = document.getElementById('copyInput')
            dom.value = content;
            dom.select()
            document.execCommand("Copy");
            this.$toast('复制成功')
        },
        submit(type, client_id, need_push) {
            console.log(client_id)
            this.showCheckList = false;
            if(type - 0 === 1){
                let info = {
                    need_push: !need_push ? 1 : 0,
                    client_id
                }
                common.myFetch(apis.saveclient, info).then(res => {
                    if(res){
                        console.log(res)
                        this.page.pageIndex = 1;
                        this.$toast('保存成功')
                        this.getClients()
                        this.clientIndex = 9999
                        this.page.pageIndex = 1;
                        this.getClientNews()
                    }
                })
            }
        },
        search(keyWord) {
            this.getClientList(keyWord)
        },
        getClientNews(id) {
            let info = {
                client_id: id || '',
                page: this.page.pageIndex,
                pagesize: this.page.pageSize
            }
            common.myFetch(apis.clientnews, info).then(res => {
                if(res){
                    console.log(res)
                    res.list.forEach(el => {
                        if(el.time_line){
                            let arr = el.time_line.split('日')
                            el.date = arr[0] + '日'
                            el.time = arr[1]
                        }
                    })
                    if(this.page.pageIndex - 0 === 1){
                        this.list = res.list;
                        this.canLoad = true;
                    }else{
                        if(res.list.length > 0){
                            this.list = this.list.concat(res.list);
                            this.canLoad = true;
                        }else{
                            this.canLoad = false;
                        }
                        
                    }
                    this.$set(
                        this.page,
                        "pageCount",
                        common.calculatePage(res.page.row_count - 0, this.page.pageSize)
                    );
                    this.$set(this.page, "total", res.page.row_count - 0);

                    this.$nextTick(() => {
                        let listDom = this.$refs.list;
                        if(listDom){
                            this.height = listDom.scrollHeight;
                        }
                    })
                }
            })
        },
        getClients() {
            common.myFetch(apis.userclient).then(res => {
                if(res){
                    this.clients = res.list
                    this.total = res.totalNum
                    this.userNum = res.userNum
                    this.need_push = res.need_push
                }
            })
        },
        getClientList(keyWord) {
            let info = {
                keyword: keyWord || ''
            }
            common.myFetch(apis.clients, info).then(res => {
                if(res){
                    res.list.forEach(el => {
                        if(el.list.length > 0){
                            let length = el.list.length
                            let num = 0

                            for (let index = 0; index < length; index++) {
                                if(el.list[index].selected){
                                    num ++
                                }
                            }

                            if(num === length){
                                el.selectAll = true
                            }else{
                                el.selectAll = false
                            }
                        }else{
                            el.selectAll = true
                        }

                        el.hide = false
                    });
                    this.clientsList = res.list
                }
            })
        }
    },
    computed: {
      getNewClient () {
        return this.$store.state.newClient
      }
    },
    watch: {
      getNewClient () {
        this.showNews = true;
      },
      showCheckList(to) {
        if(to){
            this.getClientList()
        }
      }
    },
    mounted() {
        this.$nextTick(() => {
            var list = document.querySelectorAll('.client-content > .right-container > .list')[0];   // 获取滚动条的dom
            // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            console.log(list)
            list.onscroll = () => {
                var scrollTop = list.scrollTop;
                // 获取可视区的高度
                var windowHeight = list.clientHeight;
                // 获取滚动条的总高度
                var scrollHeight = list.scrollHeight;
                if(scrollTop+windowHeight>=scrollHeight - 200){
                    if(this.canLoad){
                        this.canLoad = false;
                        this.page.pageIndex ++;
                        this.getClientNews(this.client_id);
                    }
                }
            }
        });
    },
    created() {
        this.headLines.title = '客户端动态';
        this.getClients()
        this.getClientList()
        this.getClientNews()
        let id = this.$route.query.id
        if(id) {
            this.toDetail(id)
        }
    }
}
</script>

<style scoped lang="less">
    .client-container {
        .client-content {
            display: flex;
            flex-direction: row;
            justify-content: center;
            width: 100%;
            height: calc(100vh - 70px);
            padding: 30px 20px 50px;
            box-sizing: border-box;

            .left-container {
                display: flex;
                flex-direction: column;
                min-width: 210px;
                height: 100%;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                margin-right: 20px;

                .title {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 54px;
                    padding: 0px 20px;
                    box-sizing: border-box;
                    font-size: 16px;
                    line-height: 22px;
                    color: #050F0F;
                    font-weight: bold;

                    p {
                        display: flex;
                        align-items: center;
                        width: 100%;
                        height: 54px;
                        padding-left: 10px;
                        font-size: 16px;
                        line-height: 22px;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;
                    }
                }

                .content {
                    width: 100%;
                    flex: 1;
                    overflow-y: auto;
                    padding: 9px 0;
                    box-sizing: border-box;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 2px;
                    }

                    ul {
                        display: flex;
                        flex-direction: column;

                        li {
                            width: 100%;
                            height: 42px;
                            font-size: 14px;
                            line-height: 42px;
                            color: #050F0F;
                            font-weight: bold;
                            padding-left: 40px;
                            box-sizing: border-box;
                            user-select: none;
                            cursor: pointer;

                            &:hover {
                                position: relative;
                                background: #EFF5F3;
                                color: #41B48C;

                                &:after {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    display: block;
                                    content: '';
                                    width: 4px;
                                    height: 100%;
                                    background-color: #41B48C;
                                }
                            }

                            &.on {
                                position: relative;
                                background: #EFF5F3;
                                color: #41B48C;

                                &:after {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    display: block;
                                    content: '';
                                    width: 4px;
                                    height: 100%;
                                    background-color: #41B48C;
                                }
                            }
                        }
                    }
                }

                .footer {
                    display: flex;
                    width: 100%;
                    height: 66px;
                    padding: 0 20px;
                    box-sizing: border-box;

                    &>div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        border-top: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        p {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 170px;
                            height: 28px;
                            background: rgba(65, 180, 140, 0.1);
                            border-radius: 4px;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                            user-select: none;
                            cursor: pointer;

                            i {
                                display: block;
                                width: 14px;
                                height: 14px;
                                background: url('../../assets/img/analysis/addIcon.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 6px;
                            }

                            span {
                                font-size: 14px;
                                line-height: 20px;
                                color: #41B48C;
                            }
                        }
                    }
                }
            }

            .right-container {
                position: relative;
                // flex: 1;
                width: 1064px;
                background: #F9F9F9;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                border-radius: 4px;
                // padding: 24px 38px 50px 123px;
                padding-top: 24px;
                padding-bottom: 50px;
                box-sizing: border-box;
                // overflow-y: auto;

                // &::-webkit-scrollbar {
                //     width: 6px;
                // }
                // &::-webkit-scrollbar-thumb {
                //     background: #ddd;
                //     border-radius: 2px;
                // }

                .progress {
                    position: absolute;
                    top: 33px;
                    left: 98px;
                    width: 1px;   
                    background: #DCDCDC;
                }

                .list {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    overflow-y: auto;
                    padding-left: 123px;
                    padding-right: 38px;
                    box-sizing: border-box;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #ddd;
                        border-radius: 2px;
                    }

                    .hasNew {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        position: absolute;
                        top: 0px;
                        left: 50%;
                        z-index: 99;
                        margin-left: -84px;
                        width: 168px;
                        height: 28px;
                        background: #E6F1ED;
                        border-radius: 14px;
                        font-size: 14px;
                        color: #050F0F;
                        user-select: none;
                        cursor: pointer;

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: url('../../assets/img/analysis/tips.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-right: 6px;
                        }
                    }
                }

                ul {
                    display: flex;
                    flex-direction: column;

                    li {
                        position: relative;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                        padding: 20px 30px 25px 14px;
                        border-bottom: 1px solid #DCDCDC;
                        box-sizing: border-box;

                        &:after {
                            position: absolute;
                            top: 26px;
                            left: -29px;
                            display: block;
                            content: '';
                            width: 9px;
                            height: 9px;
                            border-radius: 50%;
                            background: #41B48C;
                        }

                        &:hover {

                            background: rgba(185, 195, 195, 0.15);
                            .right {
                                display: block;
                            }
                        }

                        .left {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            img {
                                width: 40px;
                                height: 40px;
                                background: #D8D8D8;
                                border-radius: 50%;
                                margin-right: 12px;
                            }

                            .content {
                                display: flex;
                                flex-direction: column;

                                .title {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    p {
                                        font-size: 14px;
                                        line-height: 20px;
                                        color: #050F0F;
                                        margin-right: 16px;
                                        font-weight: bold;
                                    }

                                    i {
                                        font-size: 12px;
                                        line-height: 17px;
                                        color: #829191;

                                        &.on {
                                            display: block;
                                            width: 36px;
                                            height: 20px;
                                            line-height: 20px;
                                            text-align: center;
                                            background: rgba(65, 180, 140, 0.1);
                                            border-radius: 3px;
                                            font-size: 12px;
                                            color: #41B48C;
                                        }
                                    }
                                }

                                .content {
                                    font-size: 12px;
                                    line-height: 17px;
                                    color: #829191;
                                    margin-top: 6px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 2;
                                    -webkit-box-orient: vertical;
                                    display: -moz-box;
                                    -moz-line-clamp: 2;
                                    -moz-box-orient: vertical;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                    white-space: normal;
                                }
                            }
                        }

                        .right {
                            display: none;
                            min-width: 40px;
                            height: 30px;
                            // margin-top: 6px;
                            margin-left: 10px;
                            background: #41B48C;
                            box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.1);
                            border-radius: 4px;
                            font-size: 14px;
                            line-height: 30px;
                            text-align: center;
                            color: #FFF;
                            font-weight: bold;
                            user-select: none;
                            cursor: pointer;
                        }

                        .time {
                            position: absolute;
                            top: 22px;
                            left: -100px;
                            display: flex;
                            flex-direction: column;

                            p {
                                font-size: 14px;
                                line-height: 21px;
                                color: #050F0F;
                                font-weight: bold;
                            }
                        }
                    }
                }

                .empty1 {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    margin-top: 19px;

                    i {
                        display: block;
                        width: 18px;
                        height: 18px;
                        background: url('../../assets/img/analysis/empty.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        margin-right: 6px;
                    }

                    span {
                        font-size: 12px;
                        line-height: 17px;
                        color: #829191;
                    }
                }
            }
        }
    }
</style>